<!-- <div class="repeat-section-container"> -->
<!-- <h5>Numero di scale: {{ field.fieldGroup.length }}</h5> -->
<div class="section-repeat" *ngFor="let subField of field.fieldGroup; let i = index">
  <formly-field [field]="subField"></formly-field>
  <button mat-icon-button color="error" class="remove-row-btn" (click)="onRemoveRow(i)" *ngIf="i >= 0 && to.status && (to.status === 'open' || to.status === 'pending') && delBntenable"
    matTooltip="{{ 'common.cta.remove' | translate }}">
    <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
  </button>
</div> <!-- /.section-repeat -->
<button mat-raised-button color="primary" (click)="onAddRow()" *ngIf="to.status && to.status === 'open'">
  <mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon>
  {{ 'common.words.add' | translate }}
</button>
<!-- </div> -->